import EmojiAvatar from '@components/EmojiAvatar';
import { Button } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import React, { memo } from 'react';

const GroupResourceDetails = ({
  name,
  emoji = ':credit_card:',
  shouldShowRemoveButton,
  handleRemoveFromTeam
}) => {
  return (
    <div className="flex items-center my-2.5">
      <div className="flex w-10 h-10 justify-center items-center rounded-full shadow-md">
        <EmojiAvatar code={emoji} />
      </div>
      <div className="ml-4 flex-1 text-slate-700 font-medium">{name}</div>
      {shouldShowRemoveButton && (
        <Button className="!text-slate-400 hover:!text-red-600" onClick={handleRemoveFromTeam}>
          <CloseIcon />
        </Button>
      )}
    </div>
  );
};

export default memo(GroupResourceDetails);
